export const styleAttributeIds = {
  FILL_COLOR: 'FILL_COLOR',
  LINE_WIDTH: 'LINE_WIDTH',
  LINE_COLOR: 'LINE_COLOR',
  LINE_DASH: 'LINE_DASH',
}
